<template>
  <div class="DataTable">
    <v-form ref="form" v-model="valid" lazy-validation>
      <!--<v-layout row wrap>-->
      <!--<v-flex xs8>-->
      <!--<v-text-field-->
      <!--v-model="ID"-->
      <!--label="ID" readonly-->
      <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
      <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

      <v-layout row wrap>
        <v-flex xs4 pa-2>
          <v-text-field
            v-model="godina"
            label="Godina"
            :rules="[v => !!v || 'Obavezan podatak']"
            required
            type="number"
          ></v-text-field>
        </v-flex>

        <v-flex xs6 pa-2>
          <v-select
            v-model="select"
            :items="wt_items"
            item-text="name"
            item-value="id"
            :rules="[v => !!v || 'Obavezan podatak']"
            label="Etiketa"
            required
            persistent-hint
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs1 pa-3>
          <v-icon slot="activator"  id="FloatingButton" class="ml-2" @click="submit_parameter"
                  title="Unos nove etikete"
            >add</v-icon>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-text-field v-model="opis" label="Opis"></v-text-field>
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled">Sačuvaj</v-btn>
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>

    <v-dialog v-model="dialogNote" scrollable content-class="ModalInModal">
      <v-container style="padding:0px;">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <div
              data-v-fae5bece
              class="v-card__title headline lighten-2 v-card__title--primary"
              
            >
              <!-- Modal Titles  -->

              <div>Dodavanje nove etikete</div>

              <button
                id="closeModalBtn"
                @click.prevent="closeModal"
                class="v-btn v-btn--flat white"
                
              >
                <v-icon>close</v-icon>
              </button>
            </div>

            <div data-v-fae5bece class="spacer"></div>

            <div v-if="this.dialogNote === true">
              <WineLabel2 @mounted="customMounted" style="padding-top:0px;" />
            </div>

           

          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>
    <TokenComponent ref="frmtoken"/>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import WineLabel2 from "../views/WineLabelModal";
import TokenComponent from "../components/Token";

const MountedMixin = {
  mounted() {
    // alert(1);
    this.$emit("mounted");
  }
};

export default {
  name: "WineModalItem",
  components: {
    TokenComponent,
    WineLabel2: resolve => {
      setTimeout(() => {
        const component = WineLabel2;
        component.mixins = [];
        component.mixins.push(MountedMixin);
        resolve(component);
        // This could be the result of System.import of an async require
      }, 300);
    }
  },
  data: () => ({
    valid: true,
    ID: "0",
    godina: 0,
    wt_items: [],
    select: "",
    opis: "",
      dialogNote: false
  }),

  methods: {
    customMounted() {
      // alert(this.tankId);

      if (this.dialogNote) {

}
    },
    submit_parameter(e) {
      e.preventDefault();
      this.dialogNote = true;
    },
    closeModal() {
      this.dialogNote = false;
      this.getAllEtikete();
    },
    newSifarnik() {
      var complexObjectWineLabel = {
        id: this.select.id
      };

      var complexObject = {
        year: this.godina,
        wineLabel: complexObjectWineLabel,
        description: this.opis
      };

      //// // console.log(complexObject);

      this.$http
        .post(this.globalServiceLocation + this.globalPort + "/wine/create", complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          serverBus.$emit("refresh_wine_modal");
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .post(this.globalServiceLocation + this.globalPort + "/wine/create", complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          serverBus.$emit("refresh_wine_modal");
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    changeSifarnik() {
      var complexObjectWineLabel = {
        id: this.select.id
      };

      var complexObject = {
        id: this.ID,
        year: this.godina,
        wineLabel: complexObjectWineLabel,
        description: this.opis
      };

      this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/wine/update/" + this.ID,
          complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          serverBus.$emit("refresh_wine_modal");
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .put(
          this.globalServiceLocation + this.globalPort + "/wine/update/" + this.ID,
          complexObject, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              }
        )
        .then(response => {
          serverBus.$emit("refresh_wine_modal");
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    getAllEtikete() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_label/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          if (!e.response) {
              alert(this.$t("error.message"));
            } else {
                if (e.response.status === 401) {

            this.$refs.frmtoken.osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
              .then(result => {
                // // console.log(result);
                // // console.log("Novi token - " + localStorage.getItem("user-token"));

                this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_label/all", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer  " + localStorage.getItem('user-token')
                }
              })
        .then(response => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch(e => {
          // // console.log(e.response);

          let pomError = readJSON(e.response.data.message);
          alert(pomError);
        });
              });
          } else {
            let pomError = readJSON(e.response.data.message);
            alert(pomError);
          }
            }
        });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (this.ID != "" && this.ID != "0") {
          this.changeSifarnik();
        } else {
          this.newSifarnik();
        }

        this.clear();
      }
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;
    }
  },
  mounted() {
    this.clear();
    var d = new Date();
    this.godina = d.getFullYear();

    this.getAllEtikete();

    serverBus.$on("applied_wine_modal", item => {
      //alert(item.name);
      this.ID = item.id;
      this.godina = item.year;
      this.opis = item.description;

      if (item.wineLabel !== null) {
        this.select = item.wineLabel;
      } else {
        this.select = "";
      }
    });
  }
};
</script>
    
<style lang="scss" scoped>
@import "./../assets/sass/parts/modalStyles";

.wineItemComponentForm {
  max-width: 430px;
}
.Description textarea {
  height: 40px;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

#FloatingButton {
    position: absolute;
    width: 36px;
    height: 36px;
    font-size: 25px;
    border-radius: 50%;
    color: #ffffff;
    background-color: #018389;
    // transition: .2s ease-in-out;
    // p {
    //   position: relative;
    //   width: 100%;
    //   height: 100%;
    //   i {
    //     position: absolute;
    //     left: 6px;
    //     top: 6px;
    //     transform: rotate(45deg);
    //     color: #ffffff;
    //   }
    // }
    &:active, &:focus {
      box-shadow: none;
    }
}
</style>
